import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import OnBoardingForms from './OnBoardingForms';
import OnBoardingSidebar from './OnBoardingSidebar';
import { OnBoardingContainerStyled } from './styles';

const OnBoarding = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const params = useParams();
  const { onboardingCurrentStep } = params;

  useEffect(() => {
    if (onboardingCurrentStep) {
      setCurrentStep(+onboardingCurrentStep);
    }
  }, [onboardingCurrentStep]);

  return (
    <OnBoardingContainerStyled>
      <OnBoardingSidebar currentSteps={currentStep} />
      <OnBoardingForms
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />
    </OnBoardingContainerStyled>
  );
};

export default OnBoarding;
